import { ToolsPanelToggleButton } from "../controls";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

type FilterToggleButtonProps = {
    isActivated: boolean;
    setIsActivated: React.Dispatch<React.SetStateAction<boolean>>;
    tooltipTextWhenActivated: string;
    tooltipTextWhenDeactivated: string;
};

export function ExpandToggleButton({
    isActivated,
    setIsActivated,
    tooltipTextWhenActivated,
    tooltipTextWhenDeactivated,
}: FilterToggleButtonProps) {
    return (
        <ToolsPanelToggleButton
            isActivated={isActivated}
            setIsActivated={setIsActivated}
            tooltipTextWhenActivated={tooltipTextWhenActivated}
            tooltipTextWhenDeactivated={tooltipTextWhenDeactivated}
        >
            {
                isActivated
                    ?
                        <CloseFullscreenIcon
                            sx={{
                                height: '18px',
                                width: '18px',
                            }}
                        />
                    :
                        <OpenInFullIcon
                            sx={{
                            height: '18px',
                            width: '18px',
                            }}
                        />
            }
        </ToolsPanelToggleButton>
    )
}